import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import { Overlay } from '@gumtree/ui-library';
import SideNavBox from './side-nav-box';
import SideNavButton from './side-nav-button';

/** provides a button which will open a sliding menu drawer */

const SideNavContainer = styled.div`
    display: inline-block;
`;
class SideNav extends Component {
    state = {
        isOpen: false,
    };

    open = () => this.setState({ isOpen: true });
    close = () => this.setState({ isOpen: false });

    render() {
        const { children, dark, right, isMhhExperiment, isLoggedIn, useMhhLayout } = this.props;
        const { isOpen } = this.state;
        const { close, open } = this;

        return (
            <SideNavContainer>
                <SideNavButton
                    dark={dark}
                    onClick={this.open}
                    isMhhExperiment={isMhhExperiment}
                    isLoggedIn={isLoggedIn}
                    useMhhLayout={useMhhLayout}
                />

                <Overlay isOpen={isOpen} onClick={close} />

                <SideNavBox isOpen={isOpen} right={right}>
                    {children({ close, open })}
                </SideNavBox>
            </SideNavContainer>
        );
    }
}

SideNav.defaultProps = {
    children: () => {},
    dark: false,
    right: false,
    isMhhExperiment: false,
    isLoggedIn: false,
    useMhhLayout: false,
};

SideNav.propTypes = {
    children: PropTypes.func,
    dark: PropTypes.bool,
    right: PropTypes.bool,
    isMhhExperiment: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    useMhhLayout: PropTypes.bool,
};

export default SideNav;
